// useFetchGigs.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchGigs = () => {
    const [gigs, setGigs] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const populateGigsData = async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/gigs`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setGigs(data);
                    setLoading(false);
                } else {
                    console.error('Failed to fetch gigs:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching gigs:', error.message);
            }
        };
        populateGigsData();
    }, [getAccessTokenSilently]);

    return { gigs, loading };
};


